import {
  getData,
  setData,
  TASK_DETAILS_DETAILS_PANE_WIDTH
} from '../../models/LocalStorage';

export const DEFAULT_DETAILS_PANE_WIDTH = 360;
export const MIN_DETAILS_PANE_WIDTH = 280;
export const MIN_SCREENSHOT_PANE_WIDTH = 320;

export const clampDetailsPaneWidth = (
  width: number,
  containerWidth: number
): number => {
  const maxWidth = Math.max(
    MIN_DETAILS_PANE_WIDTH,
    containerWidth - MIN_SCREENSHOT_PANE_WIDTH
  );

  return Math.min(Math.max(width, MIN_DETAILS_PANE_WIDTH), maxWidth);
};

export const getStoredDetailsPaneWidth = (): number => {
  const stored = getData(TASK_DETAILS_DETAILS_PANE_WIDTH);

  if (typeof stored !== 'number' || !Number.isFinite(stored) || stored <= 0) {
    return DEFAULT_DETAILS_PANE_WIDTH;
  }

  return stored;
};

export const setStoredDetailsPaneWidth = (width: number): void => {
  setData(TASK_DETAILS_DETAILS_PANE_WIDTH, width);
};
